const required = (value: any): void | string => {
  if (!value || (typeof value === 'object' && !Object.values(value)?.length)) {
    return 'required';
  }
};
export default required;
